import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { cn } from "@/lib/utils";
function HeaderContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href]') as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute('href');
        if (!href) return;
        if (href === '/#') {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          return;
        }
        let hash = '';
        if (href.startsWith('#')) {
          hash = href;
        } else if (href.startsWith('/') && href.includes('#')) {
          const [path, hashPart] = href.split('#');
          if (path === '/' || path === window.location.pathname) {
            hash = '#' + hashPart;
          }
        }
        if (hash && hash !== '#') {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      }
    };
    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);
  useEffect(() => {
    if (isMobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileOpen]);
  return <>
      <header className={cn("fixed top-0 left-0 z-50 w-full transition-all duration-300 h-[80px]", isScrolled ? "bg-background/80 backdrop-blur-md border-b border-border/10" : "bg-background border-b border-transparent")}>
        <div className="container mx-auto px-4 h-full flex items-center justify-between">
          
          <Link to="/" className="flex-shrink-0">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569073/img/image_ltd7hfdk.png" alt="Website Shop" className="h-12 w-auto" />
          </Link>

          
          <div className="hidden md:flex items-center gap-1">
            {!loading && menuItems.map((item, i) => {
            const isContact = item.label.toLowerCase() === "contact";
            return isContact ? <Button key={item.id} data-index={i} asChild className="btn-primary ml-4 shadow-lg shadow-primary/20 !bg-[#f4c94b] !text-black hover:!bg-[#f4c94b]/90">
                    <Link to={item.href || "#"}>{item.label}</Link>
                  </Button> : <Link key={item.id} data-index={i} to={item.href || "#"} className="group inline-flex h-9 w-max items-center justify-center rounded-md px-4 py-2 text-sm font-medium text-foreground/80 transition-colors hover:text-primary focus:text-primary focus:outline-none disabled:pointer-events-none disabled:opacity-50">
                    {item.label}
                  </Link>;
          })}
          </div>

          
          <Button variant="ghost" size="icon" className="md:hidden text-foreground hover:text-primary hover:bg-transparent" onClick={() => setIsMobileOpen(!isMobileOpen)}>
            {isMobileOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </Button>
        </div>
      </header>

      
      {isMobileOpen && <div className="fixed top-[80px] left-0 w-full bottom-0 z-60 bg-background md:hidden flex flex-col animate-in fade-in duration-200">
          <div className="flex-1 overflow-y-auto py-12 px-6 flex flex-col gap-6 items-center">
            {!loading && menuItems.map((item, i) => {
          const isContact = item.label.toLowerCase() === "contact";
          return <div key={item.id} data-index={i} className="w-full max-w-xs">
                    {isContact ? <Button asChild className="btn-primary w-full h-12 text-lg shadow-lg shadow-primary/20 !bg-[#f4c94b] !text-black hover:!bg-[#f4c94b]/90">
                        <Link to={item.href || "#"} onClick={() => setIsMobileOpen(false)}>
                          {item.label}
                        </Link>
                      </Button> : <Link to={item.href || "#"} className="block w-full text-center py-3 text-lg font-medium text-foreground/80 hover:text-primary transition-colors" onClick={() => setIsMobileOpen(false)}>
                        {item.label}
                      </Link>}
                  </div>;
        })}
          </div>
        </div>}
    </>;
}
export default function Header() {
  return <section id="header" className="bg-background text-foreground">
      <MenuProvider menu_id="16">
        <HeaderContent />
      </MenuProvider>
    </section>;
}